export class AuditByStatusesFilter {
  constructor(
    public AuditSpecialistId?: number,
    public StartStatusDueDate?: Date,
    public EndStatusDueDate?: Date,
    public StartAuditDueDate?: Date,
    public EndAuditDueDate?: Date
  ) {}
}
